function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.707 11.293l-7-7a1 1 0 00-1.414 1.414L16.586 11H5a1 1 0 000 2h11.586l-5.293 5.293a1 1 0 101.414 1.414l7-7a1 1 0 000-1.414z",
  fill: "#fff",
  opacity: 0.4
});

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmF7b3BhY2l0eTowLjQ7fS5iLC5je2ZpbGw6I2ZmZjt9LmJ7b3BhY2l0eTowO308L3N0eWxlPjwvZGVmcz48ZyBjbGFzcz0iYSI+PHJlY3QgY2xhc3M9ImIiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPjxwYXRoIGNsYXNzPSJjIiBkPSJNMTkuNzA3LDExLjI5M2wtNy03YTEsMSwwLDAsMC0xLjQxNCwxLjQxNEwxNi41ODYsMTFINWExLDEsMCwwLDAsMCwySDE2LjU4NmwtNS4yOTMsNS4yOTNhMSwxLDAsMSwwLDEuNDE0LDEuNDE0bDctN0ExLDEsMCwwLDAsMTkuNzA3LDExLjI5M1oiLz48L2c+PC9zdmc+";
export { SvgArrowRight as ReactComponent };